import {actionMap} from '../reducers/index'
import handleError from 'shared/errorHandler/actions/handleError'
import {fetchApiAuthentication} from 'shared/actions/fetchApi'
import * as types from './types'

export default (params) => dispatch => {
    dispatch({type: types.LOGIN_START})

    return fetchApiAuthentication('/api/as/auth/authenticate', params.credentials, params.CSRF)
        .then(response => response.json())
        .then((response) => {
            dispatch({
                type: types.LOGIN_SUCCESS, response: response
            })
        }).catch((error) => {
            dispatch({type: types.LOGIN_FAILURE})
            dispatch(handleError({message: error.message, status: error.response.status,  title: "Invalid Login Attempt"}))
            window.location.error = error
        })
}

export const handler_LOGIN_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: true
    })
}

export const handler_LOGIN_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        username: action.response.username,
        authenticated: true
    })
}

export const handler_LOGIN_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        username: undefined,
        authenticated: false
    })
}


actionMap[types.LOGIN_START] = handler_LOGIN_START
actionMap[types.LOGIN_SUCCESS] = handler_LOGIN_SUCCESS
actionMap[types.LOGIN_FAILURE] = handler_LOGIN_FAILURE


// WEBPACK FOOTER //
// ./src/screens/login/actions/signIn.js